import React from 'react';
import style from '@/styles/ripple.module.css';
import ArrowButton from './icons/ArrowButton';
import Mic from './icons/Mic';
interface Props {
  isListening: boolean;
  onStopListening: VoidFunction;
}
const VoiceListeningModal = ({
  onStopListening,
  isListening
}: Props) => {
  return <div className="flex items-center justify-center min-h-screen bg-gray-500 bg-opacity-80 fixed top-0 left-0 right-0 z-50" data-sentry-component="VoiceListeningModal" data-sentry-source-file="VoiceListeningModal.tsx">
      <div className="bg-white rounded-3xl p-6 shadow-2xl w-60 max-w-sm flex flex-col items-center">
        <div className="relative w-32 h-32 flex items-center justify-center mb-6">
          {isListening && <div className={`absolute inset-0 rounded-full bg-green-100 z-0 ${style.breathe}`}></div>}

          <div className="w-24 h-24 border-4 border-green-600 rounded-full flex items-center justify-center z-10 bg-white">
            <Mic className={`${'stroke-primary-100'} fill-transparent h-12 w-12`} data-sentry-element="Mic" data-sentry-source-file="VoiceListeningModal.tsx" />
          </div>
        </div>

        <p className="text-base font-medium text-neutral-70 mb-1">
          Listening...
        </p>
        <p className="text-neutral-70 mb-8 text-sm">Please Speak</p>

        <div className="flex items-center space-x-2">
          <button className="w-8 h-8 rounded-full bg-neutral-10 text-white flex items-center justify-center transition hover:bg-neutral-20" onClick={onStopListening}>
            <ArrowButton data-sentry-element="ArrowButton" data-sentry-source-file="VoiceListeningModal.tsx" />
          </button>
        </div>
      </div>
    </div>;
};
export default VoiceListeningModal;